import universalKioskEnCommon from './universal-kiosk-en-common.json';
import universalKioskDeCommon from './universal-kiosk-de-common.json';
import webappEnCommon from './webapp-en-common.json';
import webappDeCommon from './webapp-de-common.json';

export default {
  'universal-kiosk': {
    en: {
      common: universalKioskEnCommon,
    },
    de: {
      common: universalKioskDeCommon,
    },
  },
  webapp: {
    en: {
      common: webappEnCommon,
    },
    de: {
      common: webappDeCommon,
    },
  },
};

